<template>
  <div class="swiper-bottom">
    <div class="content">
      <div class="content-item">
        <div class="flex-center">
          <img :src="require('../assets/image_1/6.png')" alt="">
          <span>9</span>
          <div class="txt">年行业深耕</div>
        </div>
        <div class="tips">
          2016年于中国广州创立
        </div>
      </div>
      <div class="content-item">
        <div class="flex-center">
          <img :src="require('../assets/image_1/6.png')" alt="">
          <span>100+</span>
          <div class="txt">服务团队</div>
        </div>
        <div class="tips">
          以诚信专业为服务的准则
        </div>
      </div>
      <div class="content-item">
        <div class="flex-center">
          <img :src="require('../assets/image_1/6.png')" alt="">
          <span>40000+</span>
          <div class="txt">企业客户</div>
        </div>
        <div class="tips">
          为企业线上经营保驾护航
        </div>
      </div>
      <div class="content-item">
        <div class="flex-center">
          <img :src="require('../assets/image_1/6.png')" alt="">
          <span>5000w</span>
          <div class="txt">研发投入</div>
        </div>
        <div class="tips">
          从零到一自主研发技术
        </div>
      </div>

      <!-- <div style="display: flex;">
        <img :src="img1" alt="" srcset="" />
        <div
          style="
            margin-left: 30px;
            text-align: left;
            display: flex;
            flex-direction: column;
            justify-content: center;
          "
        >
          <div style="color:#000000;font-size:20px">视频号分享员 | 分享购物锁定关系</div>
          <div style="font-size:16px;color:rgba(0,0,0,0.5);">小程序商城打通视频号小店，增加分享路径直接锁定关系</div>
        </div>
      </div>
      <div class="line"></div>
      <div style="display: flex;width:510px">
        <img :src="img2" alt="" srcset="" />
        <div
          style="
            margin-left: 30px;
            text-align: left;
            display: flex;
            flex-direction: column;
            justify-content: center;
          "
        >
          <div style="color:#000000;font-size:20px">超级拼团玩法  | 自动开团极速裂变</div>
          <div style="font-size:16px;color:rgba(0,0,0,0.5);">赠送开团权益，免费开团邀请，循环自动开团</div>
        </div>
      </div>       -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      img1: require("../assets/swiper-bottom1.png"),
      img2: require("../assets/swiper-bottom2.png"),
    };
  },

  methods: {},

  components: {},
};
</script>
<style>
.swiper-bottom {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.tips {
  font-weight: 400;
  font-size: 20px;
  color: #404040;
  text-align: left;
  margin-top: 16px;
}

.flex-center {
  display: flex;
  align-items: center;
}

.content {
  display: flex;
  align-items: center;
  position: relative;
  bottom: 70px;
  z-index: 2;
}

.content-item .txt {
  font-weight: bold;
  font-size: 20px;
  color: #091221;
}

.content-item span {
  font-size: 28px;
  color: #091221;
  margin-left: 9px;
  margin-right: 10px;
}

.content-item {
  width: 278px;
  height: 120px;
  padding-top: 24px;
  padding-left: 22px;
  box-sizing: border-box;
  background: #FFFFFF;
  box-shadow: 0px 3px 10px 1px rgba(0,0,0,0.1);
  margin: 0 15px;
  border: 3px solid #FFFFFF;
  z-index: 10;
  position: relative;border-radius: 8px 8px 8px 8px;
}

.line {
  height: 60px;
  width: 1px;
  margin: 0 50px;
  background-color: rgba(51, 51, 51, 0.5);
}
</style>